import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AccessControl from '~/accessControl';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import Button from '~/app/common/Button';
import Icon from '~/app/common/Icon';
import { MaterialIcons as Icons } from '~/app/common/Icon/icons';
import { route } from '~/app/helpers/route';
import usePageTitle from '~/app/hooks/usePageTitle';
import useTranslation from '~/app/hooks/useTranslation';
import { useAppHeader } from '~/app/modules/appHeader';
import { PROJECTS_ROUTES } from '~/projects/Router';
import { useStoreState } from '~/store';
import { TASK_ROUTES } from '~/tasks/Router';
import tasksClasses from '~/tasks/style.module.scss';
import { TIME_MANAGEMENT_ROUTES } from '~/timeManagement/Router';
import useAccessControl from '~/app/hooks/useAccessControl';
import List from './List';

export type WorkOrderComponent = React.FC;

const WorkOrder: WorkOrderComponent = () => {
  const { t } = useTranslation('tasks');
  const { t: tb } = useTranslation('bottomNav');
  const { t: tListing } = useTranslation('workorder.listing');
  const history = useHistory();
  const { setData, clearData } = useAppHeader();
  const hasTimeforingModule = useStoreState(state => state.tenant.hasTimeforingModule);
  const networkStatus = useStoreState(state => state.app.offline.status);
  const { checkPermission } = useAccessControl();
  const oppgaverPermission = checkPermission(PERMISSION_GROUPS.oppgaver);
  const timeManagementPermission = checkPermission(PERMISSION_GROUPS.timeManagement);

  usePageTitle(tListing('pageTitle'));

  useEffect(() => {
    setData({
      title: tListing('pageTitle'),
      subTitle: '',
      backLink: undefined,
      isTaskPage: true
    });
  }, [setData, tListing]);

  useEffect(() => {
    return () => {
      clearData();
    };
  }, [clearData]);

  const handleTaskClick = () => {
    history.push(route(TASK_ROUTES.list));
  };

  return (
    <>
      {!networkStatus && (
        <>
          <div className={tasksClasses['header']}>
            <div
              className={tasksClasses['link']}
              onClick={handleTaskClick}
            >
              {tb('task')}
            </div>
            <div className={`${tasksClasses['link']} ${tasksClasses['active']}`}>
              {t('workorder')}
            </div>
          </div>
          <List />
        </>
      )}

      {(oppgaverPermission || (hasTimeforingModule && timeManagementPermission)) && (
        <div className={tasksClasses['bottomNav']}>
          <Button className={tasksClasses['bottomButton']} to={route(PROJECTS_ROUTES.list)}>
            <Icon name={'home' as Icons} className={tasksClasses['bottomIcon']} />
            {tb('home')}
          </Button>
          {hasTimeforingModule && (
            <AccessControl requiredPermissions={PERMISSION_GROUPS.timeManagement}>
              <Button
                className={tasksClasses['bottomButton']}
                to={route(TIME_MANAGEMENT_ROUTES.list)}
              >
                <Icon name={'schedule' as Icons} className={tasksClasses['bottomIcon']} />
                {tb('timeManagement')}
              </Button>
            </AccessControl>
          )}
          {oppgaverPermission && (
            <Button className={tasksClasses['bottomButton']} to={route(TASK_ROUTES.list)}>
              <Icon name={'assignment' as Icons} className={tasksClasses['bottomIcon']} />
              {tb('task')}
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default WorkOrder;
